import React from 'react';
// mui components
import { Box, Stack, Typography } from '@mui/material';

/**
 * Bordered card grouping a set of onboarding fields (or review rows) under a
 * bold section title, per the SongFund Onboarding design. `action` renders on
 * the right of the title row (e.g. the review's Edit button).
 */
const SectionCard: React.FC<{
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, action, children }) => (
  <Box sx={{ border: '1px solid #E9E9E9', borderRadius: 3, p: '20px 24px 16px' }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{title}</Typography>
      {action}
    </Stack>
    {children}
  </Box>
);

export default SectionCard;
